import { render, staticRenderFns } from "./HomeWaiters.vue?vue&type=template&id=c3223ac8"
import script from "./HomeWaiters.vue?vue&type=script&lang=js"
export * from "./HomeWaiters.vue?vue&type=script&lang=js"
import style0 from "./HomeWaiters.vue?vue&type=style&index=0&id=c3223ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports